module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo",
    style: ('display:' + _vm.display)
  }, [_c('div', {
    staticClass: "bg dragon",
    class: _vm.style
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleCenter)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d042b98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logo/index.vue
// module id = 135
// module chunks = 1